import React from "react";
import SysEventsDetailsView from "../cimponent/SysEventsDetailsView"; 

const SysEventsDetailsContainer = ({ pageId }) => (<SysEventsDetailsView pageId={ pageId } />)

export default SysEventsDetailsContainer;